import Axios from "../api/axios";
import config from "../../config";

const getTerms = () => {
  return Axios.get(`${config.BASE_URL}terms-of-use`);
};

export default getTerms;
